import React from 'react';

import { DropdownItem, useModal } from '@vlabs/uikit';
import { toast } from 'react-toastify';

import { MoveListsToDepartmentForm } from './MoveListsToDepartmentForm';
import { useMoveListsToDepartmentTranslation } from '../i18n';
import { moveListsToDepartment } from '../moveListsToDepartment';
import type {
  MoveListsToDepartmentFormValues,
  MoveListsToDepartmentProps,
} from '../types';

function MoveListsToDepartmentDropdownItem({
  departmentId,
  listIds,
}: MoveListsToDepartmentProps): React.JSX.Element {
  const { t } = useMoveListsToDepartmentTranslation();
  const modal = useModal({ size: 'small' });

  const handleSubmit = async ({
    targetDepartmentId,
    keepViewPermission,
  }: MoveListsToDepartmentFormValues): Promise<void> => {
    try {
      await moveListsToDepartment({
        departmentId,
        listIds,
        targetDepartmentId,
        keepViewPermission,
      });
      toast.success(t('toast_success'));
      modal.close();
    } catch {
      toast.error(t('toast_error'));
    }
  };

  return (
    <React.Fragment>
      {modal.wrap(
        <MoveListsToDepartmentForm
          departmentId={departmentId}
          onCancel={modal.close}
          onSubmit={handleSubmit}
        />,
      )}

      <DropdownItem
        label={t('dropdown_item') as unknown as string}
        onClick={modal.open}
      />
    </React.Fragment>
  );
}

export { MoveListsToDepartmentDropdownItem };
